import script from "./Preview.vue?vue&type=script&lang=ts&setup=true"
export * from "./Preview.vue?vue&type=script&lang=ts&setup=true"

import "./Preview.vue?vue&type=style&index=0&id=22ba5aec&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22ba5aec"]])

export default __exports__